var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5006 21.0963V15.2598L7.99681 12.8655L6.95831 17.4578L0.539062 16.154L0.842813 14.6635L5.64281 15.654L7.37756 6.82325L5.00056 7.78275V11.0963H3.50056V6.8L7.46981 5.11925C7.97615 4.90775 8.34923 4.76775 8.58906 4.69925C8.82873 4.63058 9.04923 4.59625 9.25056 4.59625C9.55573 4.59625 9.83906 4.67667 10.1006 4.8375C10.3621 4.9985 10.5749 5.213 10.7391 5.481L11.7391 7.081C12.1659 7.76817 12.7501 8.34633 13.4918 8.8155C14.2335 9.28467 15.0697 9.5385 16.0006 9.577V11.077C14.9839 11.045 14.0012 10.7838 13.0526 10.2933C12.1037 9.80292 11.2947 9.093 10.6256 8.1635L9.88131 11.9233L12.0006 13.9618V21.0963H10.5006ZM10.7506 3.6925C10.2391 3.6925 9.80348 3.51267 9.44381 3.153C9.08415 2.79333 8.90431 2.35775 8.90431 1.84625C8.90431 1.33475 9.08415 0.899166 9.44381 0.539499C9.80348 0.179832 10.2391 0 10.7506 0C11.2621 0 11.6976 0.179832 12.0573 0.539499C12.417 0.899166 12.5968 1.33475 12.5968 1.84625C12.5968 2.35775 12.417 2.79333 12.0573 3.153C11.6976 3.51267 11.2621 3.6925 10.7506 3.6925Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskB);
export default __webpack_public_path__ + "static/media/taskB.b0ffd648ddf42173dab0dcdbdfcf486b.svg";
export { ForwardRef as ReactComponent };